import Box from '@mui/material/Box';

import IconButton from '@design-system/IconButton';
import ButtonPrimary from '@design-system/ButtonPrimary';
import IconClose from '@experimental-components/IconsComponents/Close';

import useStyles from './styles';

export function StepperDialogEndContent({
  children,
  activeScroll,
  onNext,
  onClose,
  disabledNextButton,
  labelButtonNext,
  hideIconClose,
  isMobileVersion,
}: {
  children: React.ReactNode;
  activeScroll: boolean;
  onNext: () => void;
  onClose: () => void;
  disabledNextButton: boolean;
  labelButtonNext: string;
  hideIconClose: boolean;
  isMobileVersion: boolean;
}) {
  const classes = useStyles();

  return (
    <Box className={classes.rootSectionInteraction}>
      {!isMobileVersion && (
        <Box position="absolute" right="0" top="0" zIndex="1300">
          <Box
            alignItems="center"
            bgcolor="#fff"
            boxShadow={activeScroll ? '0px 8px 40px rgba(196, 208, 237, 0.15)' : 'none'}
            display="flex"
            justifyContent="end"
            padding="2rem 0 0 0"
          >
            <Box>{!hideIconClose && <IconButton onClick={onClose} size="large" startIcon={<IconClose />} />}</Box>
          </Box>
        </Box>
      )}
      <Box className={classes.wrapperEndContent}>
        {children}
        {onNext && (
          <Box className={classes.wrapperContentButton}>
            <ButtonPrimary disabled={disabledNextButton} fullWidth onClick={onNext}>
              {labelButtonNext}
            </ButtonPrimary>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default StepperDialogEndContent;
